import { render, staticRenderFns } from "./questSidebarSection.vue?vue&type=template&id=67d8bd34&scoped=true&"
import script from "./questSidebarSection.vue?vue&type=script&lang=js&"
export * from "./questSidebarSection.vue?vue&type=script&lang=js&"
import style0 from "./questSidebarSection.vue?vue&type=style&index=0&id=67d8bd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8bd34",
  null
  
)

export default component.exports